/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Color_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Choose speaker color" |
*
* @param {Speaker_Manager_Color_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_color_aria_label = /** @type {((inputs?: Speaker_Manager_Color_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Color_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir la couleur du locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecherfarbe auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli il colore dell'altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите цвет динамика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elija el color del altavoz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择扬声器颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの色を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर का रंग चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha a cor da caixa de som.")
	return /** @type {LocalizedString} */ ("Choose speaker color")
});